import { useTranslation } from "react-i18next";
import { Badge, type BadgeProps } from "@/components/ui/badge";
import type { DerivedPaymentStatus } from "../api";

const variantByStatus: Record<DerivedPaymentStatus, BadgeProps["variant"]> = {
  paid: "success",
  scheduled: "neutral",
  overdue: "danger",
  pending: "warning",
  failed: "danger",
  refunded: "neutral",
  chargeback: "pink",
};

export function PaymentStatusBadge({ status }: { status: DerivedPaymentStatus }) {
  const { t } = useTranslation(undefined, { keyPrefix: "subscription" });
  return (
    <Badge variant={variantByStatus[status]} aria-label={t(`paymentStatus.${status}`)}>
      {t(`paymentStatus.${status}`)}
    </Badge>
  );
}
